// @ts-nocheck
import { useIsSignedInAndhasToBeSignedIn } from "@store/Framework/Store/Context/ContextHooks";
import usePrevious from "@insite/client-framework/Common/Hooks/usePrevious";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackPageViewParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackPageView";
import { RecursivePartial } from "@toolkit/Framework/Types/Common";
import { useEffect } from "react";

const baseGA = { ...ga };

Object.assign<Toolkit.GoogleAnalytics, RecursivePartial<Toolkit.GoogleAnalytics>>(ga, {
    /*
    track: {
        ...ga.track,
        pageView: (parameters: TrackPageViewParameters = {}, options?: Toolkit.GoogleAnalytics.Options) => {
            return baseGA.track.pageView(
                {
                    sample_prop: "sample_data",
                    ...parameters,
                },
                options,
            );
        },
    },
    */
    use: {
        ...ga.use,
        productInfosCallback: (productInfos: ProductInfo[], callback: () => any, canCallback?: boolean) => {
            if (canCallback === undefined) {
                canCallback = true;
            }

            const canSeePrices = useIsSignedInAndhasToBeSignedIn();
            const previousProductInfos = usePrevious(productInfos);

            const allowCallback =
                canCallback &&
                Boolean(productInfos?.length) &&
                (canSeePrices
                    ? productInfos.every(x => x.pricing && x.inventory)
                    : previousProductInfos?.[0]?.productId !== productInfos?.[0]?.productId);

            useEffect(() => {
                if (allowCallback) {
                    callback();
                }
            }, [allowCallback]);
        },
    },
});
